<!--eslint-disable-->
<template>
  <el-scrollbar id="menuTheme" wrap-class="scrollbar-wrapper">
    <el-menu
      :show-timeout="200"
      :collapse="isCollapse"
      :default-active="$route.path"
      :background-color="variables.menuBg"
      :text-color="variables.menuText"
      :unique-opened="true"
      :active-text-color="variables.menuActiveText"
      :collapse-transition="false"
      mode="vertical"
    >
      <sidebar-item v-for="route in routes" :key="route.path" :item="route" :base-path="route.path"/>
    </el-menu>
  </el-scrollbar>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapState } from 'vuex';
import SidebarItem from './SidebarItem';
import {getCurrentMenu} from "@/api/service";

export default {
  components: { SidebarItem },
  data() {
    return {
      routes: this.$router.options.routes.filter(it => it.isMenu),
      variables: {
        // menuBg: '#FFFFFF',
        // menuText: '#737578',
        // menuActiveText: '#FFFFFF'
      }
    }
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    isCollapse() {
      return !this.sidebar.opened;
    }
  },
  created() {
    function loadCssCode(code) {
      let style = document.getElementById('menu-theme')
      if (!style) {
        style = document.createElement('style')
        style.id = 'menu-theme'
      }
      try {
        // 清空之前的内容
        style.innerText = ''
        // for Chrome Firefox Opera Safari
        style.appendChild(document.createTextNode(code))
      } catch (ex) {
        // for IE
        style.styleSheet.cssText = code
      }
      var head = document.getElementsByTagName('head')[0]
      head.appendChild(style)
    }
    const menuActiveText = '#4296ff'
    const menuText = '#666666'
    const subBgColor = '#f4f4f4'
    const subHoverColor = '#d9eaff'
    // background: -webkit-linear-gradient(${topColor}, ${bottomColor}); /* Safari 5.1 - 6.0 */
    // background: -o-linear-gradient(${topColor}, ${bottomColor}); /* Opera 11.1 - 12.0 */
    // background: -moz-linear-gradient(${topColor}, ${bottomColor}); /* Firefox 3.6 - 15 */
    // background: linear-gradient(${topColor}, ${bottomColor}); /* 标准的语法 */
    const menuTheme = `
        // #menuTheme {
        //   background: #fafafa;
        // }
        // #menuTheme .el-submenu__title:hover {
        //   background: rgba(0, 0, 0, 0) !important;
        // }
        // #menuTheme .el-submenu__title {
        //   color: ${menuText}!important;
        //   background: rgba(0, 0, 0, 0) !important;
        // }
        // #menuTheme .el-menu-item:hover {
        //   background: ${subHoverColor} !important;
        // }
        // #menuTheme .el-menu-item {
        //   background: ${subBgColor} !important;
        //   color: ${menuText}!important;
        // }
        // #menuTheme .router-link-active .el-menu-item {
        //   color: ${menuActiveText}!important;
        //   background: ${subHoverColor} !important;
        // }
        // #menuTheme .router-link-active el-menu-item:hover {
        //   background: ${subHoverColor} !important;
        // }
        // #menuTheme .el-menu {
        //   background: rgba(0, 0, 0, 0) !important;
        // }
        // #menuTheme .el-submenu__title i{
        //   color: ${menuText}!important;
        // }
        // .el-menu--vertical .el-menu {
        //   background: ${subBgColor} !important;
        // }
        // .el-menu--vertical .el-menu .el-menu-item:hover {
        //   background: ${subHoverColor} !important;
        // }
    `
    loadCssCode(menuTheme)
  },
  mounted() {
    this.getCurrentMenu();
  },
  methods: {
    async getCurrentMenu () {
      let res = await getCurrentMenu();
    }
  }
}
</script>

